(() => {
  if (window.hkHomeQuickBuyInitialized) return;
  window.hkHomeQuickBuyInitialized = true;
  function initialize() {
    document.querySelectorAll('.hk-home-quick-buy__form').forEach((form) => {
      if (form.dataset.hkReady) return;
      const variantSelect = form.querySelector('select[name="id"]');
      const controls = [...form.querySelectorAll('[data-hk-option-index]')];
      const source = form.querySelector('[data-hk-variants]');
      if (!variantSelect || !source || !controls.length) return;
      let variants;
      try { variants = JSON.parse(source.textContent); } catch (_) { return; }
      form.dataset.hkReady = 'true';
      const button = form.querySelector('[name="add"]');
      const adjusted = form.querySelector('[data-hk-adjusted]');
      function showPrice() {
        const option = variantSelect.selectedOptions[0];
        form.querySelector('[data-hk-price]').textContent = option?.dataset.price || '';
        form.querySelector('[data-hk-unit]').textContent = option?.dataset.unit || '';
        button.disabled = !option || option.disabled;
      }
      function choose(changed) {
        let didAdjust = false;
        controls.forEach((control, index) => {
          const candidates = variants.filter((variant) => variant.available && controls.slice(0, index).every((prior, i) => variant.options[i] === prior.value));
          [...control.options].forEach((option) => {
            option.disabled = !candidates.some((variant) => variant.options[index] === option.value);
          });
          if (control.selectedOptions[0]?.disabled) {
            const next = [...control.options].find((option) => !option.disabled);
            if (next) { control.value = next.value; didAdjust = true; }
          }
        });
        const match = variants.find((variant) => variant.available && controls.every((control, i) => variant.options[i] === control.value));
        variantSelect.value = match ? String(match.id) : '';
        adjusted.hidden = !(changed && didAdjust);
        showPrice();
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const initial = variants.find((variant) => String(variant.id) === variantSelect.value);
      if (initial) controls.forEach((control, i) => { control.value = initial.options[i]; });
      controls.forEach((control) => control.addEventListener('change', () => choose(true)));
      variantSelect.addEventListener('change', showPrice);
      form.querySelector('[data-hk-options]').hidden = false;
      form.querySelector('[data-hk-combined-label]').hidden = true;
      variantSelect.hidden = true;
      choose(false);
    });
  }
  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', initialize);
  initialize();
})();
